// removed by extract-text-webpack-plugin
module.exports = {"component-wrapper":"styles__component-wrapper___2goM9","occurrence-wrapper":"styles__occurrence-wrapper___gi9Rv","occurrences-table-container":"styles__occurrences-table-container___15592","component-title":"styles__component-title___11X4s","occurrences-table":"styles__occurrences-table___140S0","table-header":"styles__table-header___1UQSa","occurrence-data":"styles__occurrence-data___35XZz","occurrence-value":"styles__occurrence-value___yIMxq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ReportComponents/Tables/OccurrencesTable/styles.scss
// module id = 7063
// module chunks = 0